import { Button } from "primereact/button";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FOREGROUNDCOLOR } from "../../helpers/colors";
import { Password } from "primereact/password";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ChangePasswordApi } from "../../services/AccountService";
import toast from "react-hot-toast";
import { Dialog } from "primereact/dialog";

const ChangePassword2 = () => {
  const formik = useFormik({
    initialValues: {
      currentPassword: "",
      password: "",
      passwordConfirm: "",
      phoneNumber: "",
    },
    validationSchema: Yup.object().shape({
      currentPassword: Yup.string().required(
        "لطفا کلمه عبور فعلی را وارد کنید"
      ),
      password: Yup.string().required("لطفا کلمه عبور جدید را وارد کنید"),
      passwordConfirm: Yup.string().test(
        "match",
        "تکرار کلمه عبور جدید همخوانی ندارد",
        function (passwordConfirm) {
          return passwordConfirm === this.parent.password;
        }
      ),
    }),
    onSubmit: (values) => {
      //console.log(values);
      submitChangePassword(values).then((p) => console.log("pr", p));
      formik.resetForm();
    },
  });

  const [isChangePassword, SetIsChangePassword] = useState(false);
  const navigate = useNavigate();
  const Refresh = () => {
    navigate("/");
  };

  const [showModal, SetShowModal] = useState(false);
  const submitChangePassword = async (data: any) => {
    await ChangePasswordApi(data).then(async (p) => {
      if (p.data.statusCode === 200) {
        await toast.success(p.data.message);
        SetIsChangePassword(false);
        formik.setFieldValue("currentPassword", "");
        formik.setFieldValue("password", "");
        formik.setFieldValue("passwordConfirm", "");
      } else {
        await toast.error(p.data.message);
      }
    });
  };

  return (
    <>
      {/* start change pass word  */}

      <div className="mt-3 ">
        <>
          <div className="mt-1 card p-2">
            <div className="col-lg-12  ">
              <div className="col-12 mt-2 px-2" style={{ width: "100%" }}>
                <span className="p-float-label" style={{ width: "100%" }}>
                  <Password
                    inputClassName="p-input-icon-right"
                    toggleMask
                    {...formik.getFieldProps("currentPassword")}
                    promptLabel="کلمه فعلی را وارد کنید"
                    className="w-full"
                    style={{ width: "100%" }}
                    dir="rtl"
                    id="currentPassword"
                    inputStyle={{ width: "100%" }}
                  />
                  <label
                    style={{ right: "10px", left: "unset" }}
                    htmlFor="currentPassword"
                  >
                    کلمه عبور فعلی
                  </label>
                </span>
                {formik.touched.currentPassword &&
                formik.errors.currentPassword ? (
                  <b
                    style={{ fontSize: "0.65rem" }}
                    className="my-1 text-danger"
                  >
                    {formik.errors.currentPassword}{" "}
                  </b>
                ) : null}
              </div>
            </div>
            <div className="col-lg-12  col-xs-12 d-md-inline-flex  d-lg-inline-flex d-sm-block d-xs-inline-block">
              <div className="col-12 mt-4 px-2" style={{ width: "100%" }}>
                <span className="p-float-label" style={{ width: "100%" }}>
                  <Password
                    inputClassName="p-input-icon-right"
                    toggleMask
                    className="w-full"
                    style={{ width: "100%" }}
                    dir="rtl"
                    id="password"
                    {...formik.getFieldProps("password")}
                    promptLabel="کلمه عبور را وارد کنید"
                    weakLabel="ضعیف"
                    mediumLabel="متوسط"
                    strongLabel="ایمن"
                    inputStyle={{ width: "100%" }}
                  />

                  <label
                    style={{ right: "10px", left: "unset" }}
                    htmlFor="password"
                  >
                    کلمه عبور جدید
                  </label>
                </span>
                {formik.touched.password && formik.errors.password ? (
                  <b
                    style={{ fontSize: "0.65rem" }}
                    className="my-1 text-danger"
                  >
                    {formik.errors.password}{" "}
                  </b>
                ) : null}
              </div>
            </div>
            <div className="col-lg-12  col-xs-12 d-md-inline-flex  d-lg-inline-flex d-sm-block d-xs-inline-block">
              <div className="col-12 mt-4 px-2" style={{ width: "100%" }}>
                <span className="p-float-label" style={{ width: "100%" }}>
                  <Password
                    inputClassName="p-input-icon-right"
                    {...formik.getFieldProps("passwordConfirm")}
                    toggleMask
                    className="w-full"
                    style={{ width: "100%" }}
                    dir="rtl"
                    id="passwordConfirm"
                    promptLabel="کلمه عبور را مجددا وارد کنید"
                    weakLabel="ضعیف"
                    mediumLabel="متوسط"
                    strongLabel="ایمن"
                    inputStyle={{ width: "100%" }}
                  />
                  <label
                    style={{ right: "10px", left: "unset" }}
                    htmlFor="passwordConfirm"
                  >
                    تکرار کلمه عبور جدید
                  </label>
                </span>
                {formik.touched.passwordConfirm &&
                formik.errors.passwordConfirm ? (
                  <b
                    style={{ fontSize: "0.65rem" }}
                    className="my-1 text-danger"
                  >
                    {formik.errors.passwordConfirm}{" "}
                  </b>
                ) : null}
              </div>
            </div>
            <div className="col-12 mt-2 " style={{ width: "100%" }}>
              <div className="px-2" style={{ display: "inline-flex" }}>
                <Button
                  label="ثبت"
                  style={{ width: "100%" }}
                  onClick={() => SetShowModal(true)}
                  //onClick={formik.submitForm}
                  className="mt-3 p-button-success"
                />
              </div>
            </div>
          </div>
        </>
      </div>

      <Dialog
        id="test"
        style={{ width: "50vw", display: "inline-flex" }}
        visible={showModal}
        onHide={() => SetShowModal(false)}
      >
        <h3>آیا مایل به تغییر کلمه عبور خود هستید ؟</h3>
        <div style={{ backgroundColor: "transparent", textAlign: "center" }}>
          <Button
            label="بله"
            style={{ margin: "auto", width: "40%", display: "" }}
            onClick={() => {
              SetShowModal(false);
              formik.submitForm();
            }}
            className="mt-3 p-button-success"
          />{" "}
          <Button
            label="خیر"
            style={{ margin: "auto", width: "40%", display: "" }}
            onClick={() => SetShowModal(false)}
            //onClick={formik.submitForm}
            className="mt-3 p-button-success"
          />
        </div>
      </Dialog>
      {/* end change password */}
    </>
  );
};
export default ChangePassword2;
